export function resolveFtlOfferBaseUsd(offer: unknown): number {
  if (offer == null || typeof offer !== "object" || Array.isArray(offer)) return 0;
  const rec = offer as Record<string, unknown>;
  const n = (v: unknown): number | undefined => {
    if (typeof v === "number" && Number.isFinite(v)) return v;
    if (typeof v === "string" && v.trim() !== "") {
      const x = Number(v);

      return Number.isFinite(x) ? x : undefined;
    }
    return undefined;
  };
  const candidates = [
    n(rec.totalRate),
    n(rec.totalBilledRate),
    n(rec.billed),
    n(rec.tmsRate),
    n(rec.listRate),
    n(rec.price),
    n(rec.suggestedCost),
    n(rec.appliedCost),
  ];

  for (const c of candidates) {
    if (c != null && c > 0) return c;
  }
  const dist = n(rec.distance) ?? 0;
  const perMi = n(rec.targetBuyRate) ?? 0;

  if (dist > 0 && perMi > 0) return perMi * dist;
  return 0;
}
